import useFormPopupStyles from './UseFormPopupStyles';

export {
	useFormPopupStyles
};